(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/news/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/sport/news/assets/javascripts/init.js'); 
'use strict';

(function() {
  svs = svs || {};
  svs.sport = svs.sport || {};
  svs.sport.news = svs.sport.news || {};
  svs.sport.news.utils = svs.sport.news.utils || {};
  svs.sport.news.collections = svs.sport.news.collections || {};
  svs.sport.news.models = svs.sport.news.models || {};
  svs.sport.news.views = svs.sport.news.views || {};

  svs.sport.news.log = svs.core.log.getLogger('component:sport-news');
})();

 })(window);